<template>
	<v-switch class="mys-switch" inset
		v-model="model"
		:class="{
			selected: !!model,
			nolabel: !label,
		}"
		:hide-details="hideDetails"
		:label="label"
		:disabled="disabled"
		data-cy="dataCy"
	>
		<template v-if="$slots['label']" #label>
			<slot name="label"></slot>
		</template>
	</v-switch>
</template>

<script>
export default {
	props: {
		modelValue: Boolean,
		disabled: Boolean,
		label: String,
		hideDetails: { type: Boolean, default: true },
		dataCy: String,
	},
	computed: {
		model: {
			get() { 
				return this.modelValue 
			},
			set(value) { 
				this.$emit('update:modelValue', value ?? false)
			},
		},
	},
}
</script>

<style>
.mys-switch { margin: 0 !important; }
.mys-switch.nolabel { max-width: 44px; --v-input-control-height: 40px; }
.mys-switch .v-switch__track { background-color: #ccc; opacity: 1; }
.mys-switch.selected .v-switch__track { background-color: #00aeef; }
</style>